import titleIcon from '../../../images/icons/structure-object/text-icon.svg';
import usersIcon from '../../../images/icons/structure-object/users-icon.svg';
import descIcon from '../../../images/icons/structure-object/description-icon.svg';
import userIcon from '../../../images/icons/structure-object/user-icon.svg';
import priorityIcon from '../../../images/icons/structure-object/priority-icon.svg';
import sellingIcon from '../../../images/icons/dark/sellings-icon.svg';
import financeIcon from '../../../images/icons/structure-object/finance-icon.svg';
import folderIcon from '../../../images/icons/dark/projects-icon.svg';
import { StructureObjectField } from '../../enums/structure-object';
import penIcon from '../../../images/icons/edit-icon.svg';

export const structureCompany: StructureObjectField[] = [
    {
        key: 'name',
        label: "Назва",
        order: 1,
        icon: titleIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'customerType',
        label: 'Тип',
        order: 2,
        icon: priorityIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'description',
        label: 'Опис',
        order: 3,
        icon: descIcon,
        visible: true,
    },
    {
        key: 'contactEmail',
        label: 'Представник компанії',
        order: 4,
        icon: userIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'siteLink',
        label: 'Посилання на сайт',
        order: 5,
        icon: penIcon,
        isRequired: true,
        visible: true,
    }
];

export const structureCompanyOther: StructureObjectField[] = [
    {
        key: 'project',
        label: 'Проєкт',
        order: 1,
        icon: folderIcon,
        visible: true,
    },
    {
        key: 'income',
        label: 'Надходження',
        order: 2,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'expense',
        label: 'Витрати',
        order: 3,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'selling',
        label: 'Продажі',
        order: 4,
        icon: sellingIcon,
        visible: true,
    },
    {
        key: 'companyContacts',
        label: 'Контакти компанії',
        order: 5,
        icon: usersIcon,
        visible: true,
    },
]